import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import moment from 'moment';

import configureStore from './configureStore';
import App from './App';
/* eslint-disable */
import { NumberExtension } from './utils/extensions/';
/* eslint-enable */

import 'moment/locale/es';

// require('es6-promise').polyfill();

import registerServiceWorker from './registerServiceWorker';
import { checkForUpdates } from './actions/general';

// if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
//   const { whyDidYouUpdate } = require('why-did-you-update');
//   whyDidYouUpdate(React);
// }

moment.locale('es');

const store = configureStore();

const Component = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

const render = () => {
  ReactDOM.render(<Component />, document.getElementById('root'));
};

render();
if (module.hot) {
  module.hot.accept(Component => {
    render();
  });
}
registerServiceWorker(() => store.dispatch(checkForUpdates()));



// WEBPACK FOOTER //
// ./src/index.js